export default {
  'Manny Pacquiao': {
    displayName: 'Manny Pacquiao',
    logoUrl: 'flags/philippines.webp',
  },
  'Floyd Mayweather Jr': {
    displayName: 'Floyd Mayweather Jr',
    logoUrl: 'flags/united_states.webp',
  },
};
